import styled from 'styled-components';

const TagStyle = styled.span`
  font-size: 15px;
  display: inline-block;
  color: ${({theme}) => theme.body};
  background-color: ${({theme}) => theme.text};
  border-radius: 6px;
  padding: 4px 8px 4px 8px;
  width: fit-content;
  margin: 0 4px 0 0;
  transition: transform .05s ease-in-out;

  &.interactive:active {
    transform: scale(0.95);
  }

  a, span {
    color: ${({theme}) => theme.body};

  }

  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  
  white-space: nowrap;
  
  @media (max-width: 575px) {
    font-size: 13px;
  }
`;


export default TagStyle